import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const propTypes = {
  children: PropTypes.any,
};

// Scroll restoration based on https://reacttraining.com/react-router/web/guides/scroll-restoration.
const ScrollToTop = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return children;
};

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
ScrollToTop.propTypes = propTypes;

export default ScrollToTop;
